import { Box, Button, ClickAwayListener, IconButton, Menu, MenuItem, MenuList, Popover, Popper, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useRef, useState } from 'react'
import { useMeetingStore } from '../../store/meeting.store'
import { ArrowDropDown, Videocam } from '@mui/icons-material'
import { Icons } from '../../utils/utilities'
import { toast } from 'react-toastify'

const MinimizedVideoSettingsBar = ( { open, setOpen, anchorEl, placement = "bottom-start", openSettings } ) => {

    const [camsAnchorEl, setCamsAnchorEl] = useState( null )

    const { palette, border } = useTheme()

    const MeetingStore = useMeetingStore()

    const handleClose = () => {
        setCamsAnchorEl( null )
        setOpen( false )
    }

    const openBackgroundSettings = async () => {
        const openFlag = MeetingStore.getMeetingRoomLayoutSettings?.leftSideCollapseTab !== 'video Settings' ? true : !MeetingStore.getMeetingRoomLayoutSettings?.isLeftSideCollapseOpen
        const processor = MeetingStore.getVideoProcessor
        if ( processor )
            await processor.enable()
        MeetingStore.setMeetingRoomLayoutSettings( {
            leftSideCollapseTab: 'video Settings',
            isLeftSideCollapseOpen: openFlag
        } )
    }

    const handleCameraChange = value => {
        try {
            MeetingStore.setMeetingState( { cameraId: value } )
            if ( MeetingStore.getMeetingState.isVideoOn ) {
                const videoTrack = MeetingStore.getLocalVideoTrack
                if ( videoTrack )
                    videoTrack.setDevice( MeetingStore.getMeetingState.cameraId )
            }
            setCamsAnchorEl( null )
        } catch ( err ) {
            toast( "Failed to change video device!" )
            console.log( err )
        }
    }

    return (
        <Popper container={anchorEl.current} sx={{ zIndex: 3000 }} open={open} placement='top-start' anchorEl={anchorEl.current} >
            <ClickAwayListener onClickAway={handleClose} >
                <Box display="flex" flexDirection={{ md: "row", xs: "column" }} gap="10px" padding={{ xs: "10px", md: "5px 10px" }} marginBottom="5px" borderRadius="20px" bgcolor={palette.rowHover}>
                    <Button sx={{ borderRadius: "20px" }} disabled={!MeetingStore.getMeetingState?.cameraId} onClick={e => setCamsAnchorEl( e.currentTarget )} endIcon={<ArrowDropDown fontSize='small' />} startIcon={<Videocam fontSize='small' />} color="greyed" variant='outlined'>
                        <Typography color={!MeetingStore.getMeetingState?.cameraId ? "GrayText" : palette.common.font} variant='subtitle2' noWrap  >{!MeetingStore.getMeetingState?.cameraId ? "Permission required..." : MeetingStore.getIoDevices?.cameras?.find( cam => cam.deviceId === MeetingStore.getMeetingState?.cameraId )?.label}</Typography>
                    </Button>

                    <Button sx={{ borderRadius: "20px", justifyContent: "flex-start", paddingX: "15px", display: { md: "none", xs: "flex" }, "& .MuiButton-icon": { marginLeft: "0" } }} disabled={!MeetingStore.getMeetingState?.cameraId} onClick={openBackgroundSettings} startIcon={Icons.default.Settings} color="greyed" variant='text'>
                        Open Background Effects
                    </Button>

                    <Box display={{ md: "block", xs: "none" }}>
                        <Tooltip disableFocusListener disableInteractive placement='top' title="Background Effects">
                            <IconButton onClick={openBackgroundSettings} >
                                {Icons.default.AutoFixHigh}
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Popper sx={{ zIndex: 3200 }} anchorEl={camsAnchorEl} placement='top-start' open={Boolean( camsAnchorEl )}  >
                        <Box overflow='clip' marginBottom="10px" borderRadius="10px" bgcolor={palette.rowHover}>
                            <MenuList>
                                {MeetingStore.getIoDevices?.cameras.map( cam => (
                                    <MenuItem onClick={() => handleCameraChange( cam.deviceId )} selected={cam.deviceId === MeetingStore.getMeetingState?.cameraId} value={cam.deviceId} key={cam.deviceId}>{cam.label}</MenuItem>
                                ) )}
                            </MenuList>
                        </Box>
                    </Popper>
                </Box>

            </ClickAwayListener >
        </Popper>
    )
}

export default MinimizedVideoSettingsBar
